import { createAction } from 'redux-actions';

// Types
const DISABLE_RECCOMENDATIONS = 'video/DISABLE_RECCOMENDATIONS';

// Actions
export const disableRecommendationsAction = createAction(DISABLE_RECCOMENDATIONS);

const INITIAL_STATE = false;

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case DISABLE_RECCOMENDATIONS:
      return action.payload;

    default:
      return state;
  }
};
